import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import { COUNTRY_ALIAS } from "@/lib/long-tail";
import { findCity } from "@/lib/gold-data";

/**
 * Retired combinatorial matrix: /{pk|in}/{city}/{karat}/{unit}/{modifier}
 *
 * This produced ~1,700 near-identical URLs per country (city x karat x
 * unit x today/tomorrow-forecast), including fabricated "tomorrow"
 * price predictions. Every karat and unit is already shown together on
 * the consolidated city page, so these URLs now permanently redirect
 * there instead of competing with it.
 */
export const Route = createFileRoute("/$country/$city/$karat/$unit/$modifier")({
  beforeLoad: ({ params }) => {
    const raw = params as unknown as Record<string, string>;
    const country = COUNTRY_ALIAS[raw.country?.toLowerCase()];
    const city = raw.city?.toLowerCase();
    if (!country || !city || !findCity(country, city)) throw notFound();

    throw redirect({
      href: `/city/${country}/${city}`,
      statusCode: 301,
      throw: true,
    });
  },
  component: () => null,
});
